import React from "react";
import styles from "./HoverZoomLayeredImage.module.scss";

export default function HoverZoomLayeredImage({
  background,
  foreground,
  altBackground = "Background",
  altForeground = "Foreground",
  className = "",
  zoomScale = 1.12,
  zoomZ = 60,
  zoomX = 0,
  zoomY = -6,
}) {
  return (
    <div
      className={`${styles.wrap} ${className}`}
      style={{
        ["--hz-scale"]: zoomScale,
        ["--hz-x"]: `${zoomX}px`,
        ["--hz-y"]: `${zoomY}px`,
        ["--hz-z"]: `${zoomZ}px`,
      }}
    >
      <img className={styles.bg} src={background} alt={altBackground} />
      <img className={styles.fg} src={foreground} alt={altForeground} draggable={false} />
    </div>
  );
}
